// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3DCUb","text":"SelectPayment_text__2CtWr","title":"SelectPayment_title__27Ab0","btn":"SelectPayment_btn__vhmu6"};